// import axios from 'axios'
// state
const state = {
  slideCarousel: null,
  model: {
    name: 'ww',
    url: '',
    period: '',
    area: '',
    categories: []
  },
  models: [],
  listModels: null,
  modelDetail: null
}

// getters
const getters = {
  getSlideCarouselData (state) {
    return state.slideCarousel
  },
  getModel: state => {
    return state.model
  },
  getModelName: state => {
    return state.model.name
  },
  getModels: state => {
    return state.models
  },
  getListModels: state => {
    return state.listModels
  },
  getModelDetail: state => {
    return state.modelDetail
  }
}

// actions
const actions = {
  // Update data slide Carousel
  updateSlideCarousel ({ commit, state }, data) {
    const store = this
    state.kpisLast = null
    let dataService = {
      method: 'GET',
      endpoint: '/api/simulation/areasInteres',
      data: null,
      params: {
        country: 'ES',
        region: 'ES-GC',
        city: 'ES LPA'
      },
      mutation: 'UPDATE_SLIDE_CAROUSEL'
    }
    store.dispatch('callService', dataService)
  },
  getListModels ({ commit, state }, data) {
    const store = this
    state.kpisLast = null
    let dataService = {
      method: 'POST',
      endpoint: '/api/models/getByUserAndCategoryAndSubcategory',
      data: null,
      params: {
        category: 'smartcities',
        subcategory: 'medioambiente'
      },
      mutation: 'GET_LIST_MODELS'
    }
    store.dispatch('callService', dataService)
  },
  getModelDetail ({ commit, state }, data) {
    const store = this
    state.kpisLast = null
    let dataService = {
      method: 'POST',
      endpoint: '/api/models/getByUserAndModelId',
      data: null,
      params: {
        modelName: data
      },
      mutation: 'GET_MODEL_DETAIL'
    }
    store.dispatch('callService', dataService)
  }
}

// mutations
const mutations = {
  UPDATE_SLIDE_CAROUSEL (state, data) {
    state.slideCarousel = data
  },
  UPDATE_MODEL_NAME: (state, data) => {
    state.model.name = data
  },
  UPDATE_MODEL_URL: (state, data) => {
    state.model.url = data
  },
  UPDATE_MODEL_PERIOD: (state, data) => {
    state.model.period = data
  },
  UPDATE_MODEL_AREA: (state, data) => {
    state.model.area = data
  },
  UPDATE_MODEL_CATEGORIES: (state, data) => {
    state.model.categories = data
  },
  ADD_MODEL: (state, data) => {
    state.models.push(data)
  },
  GET_LIST_MODELS: (state, data) => {
    state.listModels = data
  },
  GET_MODEL_DETAIL: (state, data) => {
    state.modelDetail = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/predictiveModels.js